// 线索状态
export const LEAD_STATUS_OPTIONS = [
  { value: 'PENDING_COMMUNICATION', label: '待沟通' },
  { value: 'INVITED', label: '已邀约' },
  { value: 'TEST_DRIVED', label: '已试驾' },
  { value: 'ORDERED', label: '已下定' },
  { value: 'COMPLETED', label: '已成交' },
  { value: 'DEFEATED', label: '战败' }
]

// 是否有效
export const VALID_OPTIONS = [
  { value: 'VALID', label: '有效' },
  { value: 'INVALID', label: '无效' },
  // { value: 'UNKNOWN', label: '待确认' }
]

// 线索来源
export const LEAD_SOURCE_OPTIONS = [
  { value: 'PRIVATE', label: '私域' },
  { value: 'PUBLIC', label: '公域' }
]

// 根据 value 取 label
export function getLabel(options, value) {
  const item = options.find(o => o.value === value)
  return item ? item.label : value
}
